import { useState } from 'react';
import { fetchData } from '../../../helpers/offthreadFetcher';

export const useFetchSubRModuleData = () => {
  const [data, setData] = useState<any>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [error, setError] = useState<any>(null);

  const fetchSubRModuleData = async (url: string) => {
    setIsLoading(true);
    setError(null);

    try {
      const response = await fetchData(url);
      if (response?.sub_r_data) {
        setData(response.sub_r_data);
      } else {
        setError(new Error('Invalid response format'));
      }
    } catch (err) {
      console.error('Error fetching subR module data:', err);
      setError(err);
    } finally {
      setIsLoading(false);
    }
  };

  return { data, isLoading, error, fetchSubRModuleData };
};
